export default __webpack_public_path__ + "static/media/popToScreenshot.6b6bfe66.png";